import { Component, OnInit, Input, PLATFORM_ID, Inject, OnDestroy } from "@angular/core";
import { ComponentRendering } from "@sitecore-jss/sitecore-jss-angular";
import { BreadcrumbData } from "../breadcrumb/breadcrumb.component";
// import { IBannerImageListDataModel } from '../../models/banner-image-list.datamodel';
import { CustomDeviceDetectorService } from "../../services/custom-device-detector.service";
import { ActivatedRoute } from "@angular/router";
import { JssStylingService } from "../../jss-styling.service";
import { Subscription } from "rxjs";
import { ThemeService } from "../../services/theme.service";
import { isPlatformServer, DOCUMENT } from "@angular/common";
import { PageScrollService } from "ngx-page-scroll-core";

@Component({
    selector: "app-loan-product-page-module",
    templateUrl: "./loan-product-page-module.component.html",
    styleUrls: ["./loan-product-page-module.component.scss"],
})
export class LoanProductPageModuleComponent implements OnInit, OnDestroy {
    @Input() rendering: ComponentRendering;
    breadcrumbData = {} as BreadcrumbData;
    // bannerImageListData: IBannerImageListDataModel;
    public isMobile: boolean = false;
    public LoanData: any;
    public containerClass: any;
    sc_params: string = "";
    params: {} = { name: "Lakis" };
    dynamicClass: string;
    public energySave: boolean = false;
    energySaveSubscription: Subscription;
    _isPlatformServer: boolean = false;
    highlight: boolean = false;
    constructor(
        @Inject(PLATFORM_ID) public readonly platformId: string,
        @Inject(DOCUMENT) private document: any,
        private pageScrollService: PageScrollService,
        public themeService: ThemeService,
        private deviceDetector: CustomDeviceDetectorService,
        public activatedRoute: ActivatedRoute,
        /* private pbJssLayout: PbJssLayoutService,
        private router: Router, */
        public jssStylingService: JssStylingService
    ) {}

    ngOnInit() {
        if (!this._isPlatformServer) {
            this.isMobile = this.deviceDetector.isMobile();

            this.energySaveSubscription = this.themeService.isEnegySaveModeEnabled().subscribe((energySave) => {
                this.energySave = energySave;
            });
        }
        this._isPlatformServer = isPlatformServer(this.platformId);
        // remove this after implementation is done
        this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
        this.LoanData = (this.rendering?.fields as any)?.Loan[0]?.fields;
        this.breadcrumbData.items = (this.rendering?.fields?.result as any)?.["BreadcrumbData"];

        if(this.LoanData?.FundingAmountValue?.value =="" && this.LoanData?.DurationValue?.value =="" && this.LoanData?.Rate?.value =="" && this.LoanData?.RateTypeValue?.value =="" && this.LoanData?.LoanCostValue?.value =="" && this.LoanData?.AdditionalFeatureValue?.value =="" && this.LoanData?.CurrencyValue?.value =="" && this.LoanData?.ProcessingFeeApplicationValue?.value ==""){
            this.highlight = false;
          }
          else{
            this.highlight = true;
          }

        this.isMobile = this.deviceDetector.isMobile();
        this.containerClass = "lg:pb-flex-row-reverse";
    }
    scrollToAnchor(anchorId: string): void {
        if (!this._isPlatformServer) {
            if (anchorId) {
                this.pageScrollService.scroll({
                    document: this.document,
                    scrollTarget: "#" + anchorId,
                    scrollOffset: 120,
                    duration: 300,
                });
            }
        }
    }
    // lakisRedirect() {
    //     let btoaParams;
    //     btoaParams = this.pbJssLayout.customParamsToQueryStringObj([{ params: this.params }]).sc_params;
    //     window["history"]?.pushState({}, "", window.location.pathname + "?sc_params=" + btoaParams);
    //     this.sc_params = btoaParams;
    //     const path = "en/idiwtes/bagget" + "?sc_params=" + btoaParams;
    //     this.router.navigateByUrl(path);
    // }

    ngOnDestroy(): void {
        if (!this._isPlatformServer) {
            if (this.energySaveSubscription) {
                this.energySaveSubscription.unsubscribe();
            }
        }
    }
}
